/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLockBitcoin = createReactComponent("outline", "lock-bitcoin", "IconLockBitcoin", [["path", { "d": "M17 21v-6m2 0v-1.5m0 9v-1.5m-2 -3h3m-1 0h.5a1.5 1.5 0 0 1 0 3h-3.5m3 -3h.5a1.5 1.5 0 0 0 0 -3h-3.5", "key": "svg-0" }], ["path", { "d": "M13 21h-6a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10", "key": "svg-1" }], ["path", { "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-2" }], ["path", { "d": "M8 11v-4a4 4 0 1 1 8 0v4", "key": "svg-3" }]]);

export { IconLockBitcoin as default };
//# sourceMappingURL=IconLockBitcoin.mjs.map
